<template>
    <ul class="profile-languages">
        <li v-for="(language, index) in languages" :key="language.code" class="profile-languages__item">
            <p class="profile-languages__item__title" :data-testid="`profile-language-name-${index}`">
                {{ getLocalizedLanguageName(language.code, language.name ?? t('generic.unknown')) }}
            </p>
            <p class="profile-languages__item__subtitle" :data-testid="`profile-language-level-${index}`">
                {{ t(`profile.new.language.level.${language.level}`) }}
            </p>
        </li>
    </ul>
</template>

<script setup lang="ts">
    import {useLanguageFormatter, useTranslation} from '#imports';
    import type {LanguageItem} from '~/components/_common/language/LanguageItem';

    const {t} = useTranslation();
    const {getLocalizedLanguageName} = useLanguageFormatter();

    const {languages = []} = defineProps<{
        languages?: LanguageItem[];
    }>();
</script>

<style lang="scss">
    .profile-languages {
        list-style-type: none;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        flex-grow: 1;
        gap: var(--joy-core-spacing-2) var(--joy-core-spacing-8);
        margin-top: 0;
        margin-bottom: 0;

        &__item {
            &__title {
                font-size: var(--joy-font-size-primary-300);
                font-weight: var(--joy-font-weight-bold);
                margin-bottom: 0;
            }

            &__subtitle {
                font-size: var(--joy-font-size-primary-300);
                margin-top: var(--joy-core-spacing-1);
                margin-bottom: var(--joy-core-spacing-1);
                color: var(--joy-color-text-default);
            }
        }
    }
</style>
